import History from "views/History.js";
import StatisticPage from "views/Statistics";
import Timer from "views/Timer.js";
import AllDataViewer from "views/AllDataViewer";
import FATE from "views/FATE.js";
import Train from "views/Train.js";
import SingleRankTimer from "views/SingleRankTimer";
import TrainSchedule from "views/TrainSchedule";

const routes = [
  {
    path: "/fullTimer",
    name: "allDCTimer",
    icon: "fa-solid fa-clock",
    component: AllDataViewer,
    layout: "Timer"
  },
  {
    path: "/timer",
    name: "allRankTimer",
    icon: "fa-solid fa-clock",
    component: Timer,
    layout: "Timer"
  },
  {
    path: "/srank",
    name: "srankTimer",
    icon: "fa-solid fa-s",
    component: SingleRankTimer,
    layout: "Timer"
  },
  {
    path: "/arank",
    name: "arankTimer",
    icon: "fa-solid fa-a",
    component: SingleRankTimer,
    layout: "Timer"
  },
  {
    path: "/fate",
    name: "fateTimer",
    icon: "fa-solid fa-clock",
    component: FATE,
    layout: "Timer"
  },
  {
    path: "/train",
    name: "trainTool",
    icon: "fa-solid fa-train-subway",
    component: Train,
    layout: "Timer"
  },
  {
    path: "/schedule",
    name: "trainSchedule",
    icon: "fa-solid fa-train-subway",
    component: TrainSchedule,
    layout: "Timer"
  },
  {
    path: "/statistic",
    name: "statistic",
    icon: "fa-solid fa-chart-simple",
    component: StatisticPage,
    layout: "Timer"
  },
  {
    path: "/history",
    name: "history",
    icon: "fa-solid fa-history",
    component: History,
    layout: "Timer"
  },
];

export default routes;
